export const getIsTariffAccumsFttbDivideEnabled = () =>
  typeof window !== 'undefined' && !!window?.abTestChoices?.elkTariffAccumsFttbDivideEnabled;
